import { toast } from "sonner";
import request from "../../../helpers/request";

export const getAllNomeDeUsuariosPorLoja = async (
  idCliente: number,
  idLoja: number | null | undefined = null,
) => {
  const lojaParam = idLoja ? `&idLoja=${idLoja}` : "";
  const url = `${process.env.REACT_APP_API}/Alerta/GetPreviewUsuarios?idCliente=${idCliente}${lojaParam}`;

  console.log("getAllNomeDeUsuariosPorLoja", url);

  const result = await request({
    url,
    method: "GET",
  });

  return result.data;
};
